export const ValidationPatterns = {
  PAN_PATTERN: "^[a-zA-Z]{3}[CPHFATBLJGcphfatbljg]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$",
  INDIVIDUAL_PAN_PATTERN: "^[a-zA-Z]{3}[Pp]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$",
  NON_INDIVIDUAL_PAN_PATTERN: "^[a-zA-Z]{3}[ABCFHTabcfht]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$",
  PERSON_NAME_PATTERN: "^[a-zA-Z\\s]+$",
  POSTAL_CODE_PATTERN: "^[0-9]{6}$",
  IFSC_PATTERN: "^[A-Za-z]{4}0[A-Z0-9a-z]{6}$",
  IFSC_FIRST_PART_PATTERN: "^[A-Za-z]{4}$",
  IFSC_SECOND_PART_PATTERN: "^0[A-Z0-9a-z]{6}$",
  PHONE_NUMBER_PATTERN: "(^[6-9][0-9]{9}$)",
  YEARS_PATTERN: "^[0-9]{1,2}$",
  MONTHS_PATTERN: "(^0$|^0?[0-9]$|^1[01]$)",
  NUMBER_PATTERN: "(^[0-9]+$)",
  NON_EMPTY_ALPHABET_STRING_PATTERN: "^[a-zA-Z\\s]+$",
  NUMBER_WITH_OPTIONAL_DECIMAL_PATTERN: "(^[0-9]+[.]*[0-9]+$|^[0-9]+$)",
  EMAIL_PATTERN: "^[a-zA-Z0-9\\+\\.\\_\\%\\-\\+]{1,256}" + "\\@"
    + "[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}" + "(" + "\\." + "[a-zA-Z0-9][a-zA-Z0-9\\-]{1,25}" + ")+$",
  GST_PATTERN: "(^([0][1-9]|[1-2][0-9]|[3][0-7]))([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1}$)",
  ALPHA_NUMERIC_PATTERN: "^[a-zA-Z0-9]+$",
  FOUR_DIGIT_NUMBER_PATTERN: "^\\d{4}$",
  CHAR_ONLY_MIN_THREE:"^[a-zA-Z ]{3,}$",
  PASSWORD_PATTERN: "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?!.*[\\s]).{6,50}$",
};
